import { render, staticRenderFns } from "./ConfirmCancel.vue?vue&type=template&id=1894fc68&scoped=true"
import script from "./ConfirmCancel.vue?vue&type=script&lang=js"
export * from "./ConfirmCancel.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCancel.vue?vue&type=style&index=0&id=1894fc68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894fc68",
  null
  
)

export default component.exports